// Page var definition
const page = {
    config: {

    },
    v: {
        firstLoad: true,
        loading: {
            update: function(){
                var l = page.v.loading;
                if(l._done) return false;
                l._op = l._cp;
                l._checksAmount = 0;
                l._checks = 0;

                if(l._ajax != 1){
                    l._cp = l._ajax * 0.5;
                    if(l._cp != l._op) page.control.preloader.progress(l._cp, 2000);
                }else{
                    if(!l._checked){
                        log.page("LOADER | Ajax Loaded");
                        l._checked = true;
                        page.check();
                    }
                    $.each(page.checklist, function(k,v){
                        if(v.needsLoad && v.enabled){
                            page.v.loading._checksAmount++;
                            page.v.loading._checks += v.progress;
                        }
                    });
    
                    l._cp = (l._ajax + l._checks) / (l._checksAmount + 1);
                    if(l._cp != l._op) page.control.preloader.progress(l._cp, 2000);
                    if(l._cp == 1){
                        l._done = true;
                        log.page("LOADER | Preloading Done");
                        l._callback();
                        page.load();
                    }
                }
            },
            reset: function(){
                log.page("LOADER | Reset");
                page.control.preloader.progress(0, 1);
                page.v.loading._cp = 0;
                page.v.loading._op = 0;
                page.v.loading._ajax = 0;
                page.v.loading._checks = 0;
                page.v.loading._checksAmount = 0;
                page.v.loading._done = false;
                page.v.loading._checked = false;

                $.each(page.checklist, function(k,v){
                    v.reset();
                });
            },
            _cp: 0,
            _op: 0,
            _ajax: 0,
            _checks: 0,
            _checksAmount: 0,
            _checked: false,
            _callback: function(){},
            _done: false
        },
        time: {
            old: 0,
            now: 0,
            delta: 0,
            set current(tm){
                page.v.time.old = page.v.time.now;
                page.v.time.now = tm;
                page.v.time.delta = page.v.time.now - page.v.time.old;
            },
            get current(){
                return page.v.time.now;
            }
        },
        scroll: {
            config: {
                damp: 0.05 // Scroll smooth greitis
            },

            old: 0,
            now: 0,
            delta: 0,
            smooth: 0,

            p_now: 0,
            p_old: 0,
            p_delta: 0,
            p_smooth: 0,

            update: function(){
                var v = page.v.scroll;
                var s = $(window).scrollTop(),
                d = $(document).height(),
                c = $(window).height() + $(".footer").outerHeight();
                
                v.now = s;
                //v.p_now = Math.min(s / (d - c), 1);
                if(d != c){
                    v.p_now = Math.min(s / (d - c), 1);
                }else{
                    v.p_now = 0;
                }
            },
            calc: function(){
                var v = page.v.scroll;

                v.delta = v.now - v.old;
                v.old = v.now;

                v.p_delta = v.p_now - v.p_old;
                v.p_old = v.p_now;

                if(v.now != v.smooth){
                    v.smooth = Math.round(THREE.Math.lerp(v.smooth, v.now, v.config.damp));
                    if(Math.abs(v.smooth - v.now) <= 1/v.config.damp){
                        v.smooth = v.now;
                    }
                }
                if(v.p_now != v.p_smooth){
                    v.p_smooth = THREE.Math.lerp(v.p_smooth, v.p_now, v.config.damp);
                    if(Math.abs(v.p_smooth - v.p_now) <= 0.0001){
                        v.p_smooth = v.p_now;
                    }
                }
                //wgl.vars.scrollSmooth = THREE.Math.lerp(wgl.vars.scrollSmooth, wgl.vars.scroll, wgl.vars.scrollDamp);
            }
        },
        mouse: {
            x:  0,
            y:  0,
            dx: 0,
            dy: 0,
            _x: 0,
            _y: 0,

            px: 0,
            py: 0,
            pdx: 0,
            pdy: 0,
            _px: 0,
            _py: 0,

            update: function(e){
                var v = page.v.mouse;
                v.x = e.clientX;
                v.y = e.clientY;

                v.px = e.clientX / window.innerWidth * 2 - 1;
                v.py = e.clientY / window.innerHeight * 2 - 1;
            },

            calc: function(){
                var v = page.v.mouse;
                v.dx = v.x - v._x;
                v.dy = v.y - v._y;
                v._x = v.x;
                v._y = v.y;

                v.pdx = v.px - v._px;
                v.pdy = v.py - v._py;
                v._px = v.px;
                v._py = v.py;
            }
        },
        models: {
            godrays: {
                aTarget: 0,
                aVal: 1,
                aStart: 0,
                aStep: 0
            }
        },
        quality: {
            resolution: 1,
            banga: 0.00001,
            medis_lapai: 0.0001,
            medis_kotas: 0.0001,
            loader: 40,
            clouds: true,
            val: 5
        }
    },
    checklist: {},


    main: {
        init: null,
        initOnce: null,
        resize: null,
        scroll: null,
        calc: null,
        render: null,
        v: {},
        f: {}
    },

    three: {
        v:{
            camRotation: 0.1,
            camSpeed: 0.03,
            readyToShow: false,
            alwaysRender: false,
            isMain: false,
            bgDone: true,

            bg: {
                aTarget: 0,
                aVal: 0,
                aStep: 1,
                cTarget: 0,
                cVal: 0,
                cStart: 0,
                cStep: 1
            },
            preloader: {
                aTarget: 0,
                aVal: 0,
                aStep: 1,
                
                progress: 0,
                pTarget: 0,
                pVal: 0,
                pStart: 0,
                pStep: 1,

                wait: 0
            },
            transition: {
                aTarget: 0,
                aVal: 0,
                aStart: 0,
                aStep: 0,

                time: 0,
                speed: 0,
                sTarget: 0,
                sStart: 0,
                sVal: 0,
                sStep: 0,
                

                scroll: 0,
                rSpeed: 0.05,
                rTarget: 0,
                scrollEnabled: false
            },
            models: {
                loaded: false,
                loader: {
                    loading: 0,
                    loaded: 0,
                    progress: 0
                },

                alpha: 0,
                aTarget: 0,
                aVal: 0,
                aStart: 0,
                aStep: 0
            }
        },
        control: {
            bg: {
                fadeIn: null,
                fadeOut: null,
                setColor: null,
                fadeColor: null,
            },
            preloader: {
                show: null,
                hide: null,
                fadeIn: null,
                fadeOut: null,
                progress: null,
            },
            transition: {
                fadeTo: null,
                speedTo: null,
                scroll: null,
                scrollEnable: null
            },
            models : {
                load: null
            }
        },
        f: {
            bg: {
                calc: null
            },
            preloader: {
                calc: null
            },
            transition: {
                calc: null
            },
            models: {
                calc: null,
                loadedMore: null,
                init: null
            }
        },
       // domain: '',
        texture:{
            lapas: {
                path: "https://agrorodeo.lt/wp-content/themes/agro/assets/3d/sprite/lapas.png",
              //  path: "https://beta.evomedia.lt/agrorodeo.lt/wp-content/themes/agro/assets/3d/sprite/lapas.png",
         //       path: "http://localhost/agrorodeo.lt/wp-content/themes/agro/assets/3d/sprite/lapas.png",
            //    path: "https://dev.evomedia.lt/agrorodeo.lt/wp-content/themes/agro/assets/3d/sprite/lapas.png",
                tex: null
            },
            godrays: {
                path: "https://agrorodeo.lt/wp-content/themes/agro/assets/3d/sprite/m8.jpg",
               // path: "https://beta.evomedia.lt/agrorodeo.lt/wp-content/themes/agro/assets/3d/sprite/m8.jpg",
        //        path: "http://localhost/agrorodeo.lt/wp-content/themes/agro/assets/3d/sprite/m8.jpg",
              //  path: "https://dev.evomedia.lt/agrorodeo.lt/wp-content/themes/agro/assets/3d/sprite/m8.jpg",
                tex: null
            },
            ball: {
                path: "https://agrorodeo.lt/wp-content/themes/agro/assets/3d/sprite/ball2.png",
             //  path: "https://beta.evomedia.lt/agrorodeo.lt/wp-content/themes/agro/assets/3d/sprite/ball2.png",
          //      path: "http://localhost/agrorodeo.lt/wp-content/themes/agro/assets/3d/sprite/ball2.png",
            //    path: "https://dev.evomedia.lt/agrorodeo.lt/wp-content/themes/agro/assets/3d/sprite/ball2.png",
                tex: null
            }
        },
        model:{
            banga: {
               path: "https://agrorodeo.lt/wp-content/themes/agro/assets/3d/banga_p007.gltf",
        //         path: "http://localhost/agrorodeo.lt/wp-content/themes/agro/assets/3d/banga_p007.gltf",
               //path: "https://beta.evomedia.lt/agrorodeo.lt/wp-content/themes/agro/assets/3d/banga_p007.gltf",
             //   path: "https://dev.evomedia.lt/agrorodeo.lt/wp-content/themes/agro/assets/3d/banga_p007.gltf",
                mesh: null
            },
            bangaLand: {
                path: "https://agrorodeo.lt/wp-content/themes/agro/assets/3d/banga006.gltf",
               // path: "https://beta.evomedia.lt/agrorodeo.lt/wp-content/themes/agro/assets/3d/banga006.gltf",
          //      path: "http://localhost/agrorodeo.lt/wp-content/themes/agro/assets/3d/banga006.gltf",
           //     path: "https://dev.evomedia.lt/agrorodeo.lt/wp-content/themes/agro/assets/3d/banga006.gltf",
                mesh: null
            },
            zeme: {
                path: "https://agrorodeo.lt/wp-content/themes/agro/assets/3d/zeme_001.gltf",
                //  path: "https://beta.evomedia.lt/agrorodeo.lt/wp-content/themes/agro/assets/3d/zeme_001.gltf",
          //     path: "http://localhost/agrorodeo.lt/wp-content/themes/agro/assets/3d/zeme_001.gltf",
             //    path: "https://dev.evomedia.lt/agrorodeo.lt/wp-content/themes/agro/assets/3d/zeme_001.gltf",

                mesh: null
            },
            medis: {
               path: "https://agrorodeo.lt/wp-content/themes/agro/assets/3d/medis004.gltf",
             //  path: "https://beta.evomedia.lt/agrorodeo.lt/wp-content/themes/agro/assets/3d/medis004.gltf",
            //    path: "http://localhost/agrorodeo.lt/wp-content/themes/agro/assets/3d/medis004.gltf",
            //    path: "https://dev.evomedia.lt/agrorodeo.lt/wp-content/themes/agro/assets/3d/medis004.gltf",
                mesh: null
            }

        },
        init: null,
        calc: null,
        render: null,
        resize: null
    },


    control: {
        preloader: {
            show: null,
            hide: null,
            progress: null
        },
        bg: {
            setColor: null,
            fadeColor: null,
        },
        particles: {
            fadeTo: null,
            speedTo: null,
            scrolling: null
        },
        models: {
            update: function(){
                var a = page.three.v.models.alpha;
                var ta = page.control.models.godrays._a * a;
                if(page.three.godRays.uniforms.opacity.value != ta) page.three.godRays.uniforms.opacity.value = ta;
                if(page.three.godRays.uniforms.opacity.value < 0.001){
                    page.three.godRays.enabled = false;
                }else{
                    page.three.godRays.enabled = true;
                }

                ta = page.control.models.clouds._a * a;
                if(page.three.clouds.uniforms.opacity.value != ta) page.three.clouds.uniforms.opacity.value = ta;
                if(page.three.clouds.uniforms.opacity.value<0.001){
                    page.three.clouds.enabled = false;
                }else{
                    page.three.clouds.enabled = true;
                }

                ta = page.control.models.banga._a * a;
                if(page.three.banga.material.uniforms.uAlpha.value != ta) page.three.banga.material.uniforms.uAlpha.value = ta;
                if(page.three.banga.material.uniforms.uAlpha.value<0.001){
                    page.three.banga.visible = false;
                }else{
                    page.three.banga.visible = true;
                }

                ta = page.control.models.bangaLand._a * a;
                if(page.three.bangaLand.material.uniforms.uAlpha.value != ta) page.three.bangaLand.material.uniforms.uAlpha.value = ta;
                if(page.three.bangaLand.material.uniforms.uAlpha.value<0.001){
                    page.three.bangaLand.visible = false;
                }else{
                    page.three.bangaLand.visible = true;
                }

                ta = page.control.models.land._a * a;
                if(page.three.land.material.uniforms.uAlpha.value != ta) page.three.land.material.uniforms.uAlpha.value = ta;
                if(page.three.land.material.uniforms.uAlpha.value<0.001){
                    page.three.land.visible = false;
                }else{
                    page.three.land.visible = true;
                }

                ta = page.control.models.tree._a * a;
                if(page.three.tree.material.uniforms.uAlpha.value != ta) page.three.tree.material.uniforms.uAlpha.value = ta;
                if(page.three.tree.material.uniforms.uAlpha.value<0.001){
                    page.three.tree.visible = false;
                }else{
                    page.three.tree.visible = true;
                }
            },
            godrays: {
                get alpha() {
                    return page.control.models.godrays._a;
                },
                set alpha(a) {
                    a = Math.clamp(a,0,1);
                    page.control.models.godrays._a = a;
                },
                _a: 0,
                fadeTo: null
            },
            clouds: {
                get alpha() {
                    return page.control.models.clouds._a;
                },
                set alpha(a) {
                    a = Math.clamp(a,0,1);
                    page.control.models.clouds._a = a;
                },
                _a: 0
            },
            banga: {
                get alpha() {
                    return page.control.models.banga._a;
                },
                set alpha(a) {
                    if(!page.three.banga) return;
                    a = Math.clamp(a,0,1);
                    page.control.models.banga._a = a;
                },
                _a: 0
            },
            bangaLand: {
                get alpha() {
                    return page.control.models.bangaLand._a;
                },
                set alpha(a) {
                    if(!page.three.bangaLand) return;
                    a = Math.clamp(a,0,1);
                    page.control.models.bangaLand._a = a;
                },
                _a: 0
            },
            land: {
                get alpha() {
                    return page.control.models.land._a;
                },
                set alpha(a) {
                    if(!page.three.land) return;
                    a = Math.clamp(a,0,1);
                    page.control.models.land._a = a;
                },
                _a: 0
            },
            tree: {
                get alpha() {
                    return page.control.models.tree._a;
                },
                set alpha(a) {
                    if(!page.three.tree) return;
                    a = Math.clamp(a,0,1);
                    page.control.models.tree._a = a;
                },
                _a: 0
            },
            fadeTo: null

            //wgl.scene.add(wgl.banga);
            //wgl.scene.add(wgl.bangaLand);
            //wgl.scene.add(wgl.land);
            //wgl.scene.add(wgl.tree);
        }
    },
    state: {
        unload: function(){
            page.main.f.loadNext();
        },
    },

    check: null,
    init: null,
    load: null,
    unload: null,
    ajaxLoaded: function(p, callback){
        if(typeof(p) != "number") p = 1;
        if(typeof(callback) == "undefined") callback = function(){};
        p = Math.clamp(p, 0, 1);
        page.v.loading._ajax = p;
        page.v.loading._callback = callback;
        //if(p == 1) page.check();
        page.v.loading.update();
    },

    frame: null,
    resize: null,
    scroll: null,
    mouseMove: null,

    afterLoad: null,
    afterLoadOnce: null,

    get quality() {
        return page.v.quality.val;
    },

    set quality(q) {
        if(Number(q)!==parseInt(q)){
            console.error("Quality must be an integer from 0 (worst) to 5(best)");
            return;
        };
        q = Math.clamp(q, 0, 5);
        var v = page.v.quality;
        if(v.val == q) return;
        page.v.quality.val = q;

        switch(q){
            case 0:{
                v.resolution = 0.5;
                v.banga = 0.0001;
                v.medis_lapai = 0.0002;
                v.medis_kotas = 0.0004;
                v.loader = 20;
                v.clouds = false;
            }break;
            case 1:{
                v.resolution = 0.75;
                v.banga = 0.00008;
                v.medis_lapai = 0.0002;
                v.medis_kotas = 0.0004;
                v.loader = 20;
                v.clouds = false;
            }break;
            case 2:{
                v.resolution = 1;
                v.banga = 0.00006;
                v.medis_lapai = 0.0002;
                v.medis_kotas = 0.0004;
                v.loader = 25;
                v.clouds = false;
            }break;
            case 3:{
                v.resolution = 1;
                v.banga = 0.00004;
                v.medis_lapai = 0.0001;
                v.medis_kotas = 0.0003;
                v.loader = 30;
                v.clouds = false;
            }break;
            case 4:{
                v.resolution = 1;
                v.banga = 0.00002;
                v.medis_lapai = 0.0001;
                v.medis_kotas = 0.0002;
                v.loader = 35;
                v.clouds = false;
            }break;
            case 5:{
                v.resolution = 1;
                v.banga = 0.00001;
                v.medis_lapai = 0.0001;
                v.medis_kotas = 0.0001;
                v.loader = 40;
                v.clouds = true;
            }break;
        }
        page.f.qualityUpdate();
    },

    f: {
        qualityUpdate: null,
    }
};